import candidateApi from '~/clientApis/candidateApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { getStore } from '~/mobx/AppStore';

export const unlinkCandidateFromRegion = async (): Promise<void> => {
    const { regionStore, candidateStore } = getStore();

    try {
        await candidateApi.unlinkCandidateFromRegion(regionStore.selectedRegionId, candidateStore.selectedCandidateId);
    } catch {
        showMessageModal('error', 'Failed to unlink candidate from region');
    }
};
